import Grid from '@material-ui/core/Grid';

import ReportCard from '../form'
import ReportCardV2 from '../formV2'

export default function StandardReportStep2({
	quarter,
	list,
	currentFilledFormIndex,
	// Standard Report Answers
	fixedGeneralAnswers,
	fixedInfoAnswers,
	fixedSoundAnswers,
	mobileGeneralAnswers,
	mobileInfoAnswers,
	mobileSoundAnswers,
	// Validation
	currentSelectedError,
	openValidationModal,
	onOpenValidationModal,
	onCloseValidationModal,
	// Version
	reportVersion,
	operatorFlag
}) {
	return (
		<>
			<Grid className="w-full flex flex-col gap-y-6">
				{reportVersion === '2' || reportVersion == 2 ? (
					<ReportCardV2
						quarter={quarter}
						type={list[currentFilledFormIndex]}
						// Standard Report Answers
						fixedGeneralAnswers={fixedGeneralAnswers}
						fixedInfoAnswers={fixedInfoAnswers}
						fixedSoundAnswers={fixedSoundAnswers}
						mobileGeneralAnswers={mobileGeneralAnswers}
						mobileInfoAnswers={mobileInfoAnswers}
						mobileSoundAnswers={mobileSoundAnswers}
						// Validation
						currentSelectedError={currentSelectedError}
						openValidationModal={openValidationModal}
						onOpenValidationModal={onOpenValidationModal}
						onCloseValidationModal={onCloseValidationModal}
						operatorFlag={operatorFlag}
					/>
				) : (
					<ReportCard
						quarter={quarter}
						type={list[currentFilledFormIndex]}
						// Standard Report Answers
						fixedGeneralAnswers={fixedGeneralAnswers}
						fixedInfoAnswers={fixedInfoAnswers}
						fixedSoundAnswers={fixedSoundAnswers}
						mobileGeneralAnswers={mobileGeneralAnswers}
						mobileInfoAnswers={mobileInfoAnswers}
						mobileSoundAnswers={mobileSoundAnswers}
						// Validation
						currentSelectedError={currentSelectedError}
						openValidationModal={openValidationModal}
						onOpenValidationModal={onOpenValidationModal}
						onCloseValidationModal={onCloseValidationModal}
					/>
				)}
			</Grid>
		</>
	)
}
